var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"distance flex-row items-center"},[(_vm.distance >= 0)?_c('span',{staticClass:"value flex-wrap",class:{ 'c-primary': _vm.distance <= 20 }},[_vm._v(_vm._s(_vm.distance)+"km")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }